import {moduleUrl, sortBy} from "scriptsShared/Utils";
import axiosInstance from "scriptsShared/AxiosInstance.js";
const axios = axiosInstance;

export function arrayParams(urlParams, parName) {
    const par = urlParams.get(parName);

    if (par === null)
        return null;

    return par.split(',').map(str => parseInt(str));
}

export function initShowTable(categories) {
    categories.forEach((cat) => cat.showTable = true);
}

export function loadCategories(source, axios, selectedCategories = null, selectedCompanies = null, foreignersAnswers = {}) {
    let urlParams = new URLSearchParams(window.location.search);

    let request = {
        query: urlParams.get("query"),
        categoriesFilter: selectedCategories || arrayParams(urlParams, 'cat'),
        companiesFilter: selectedCompanies || arrayParams(urlParams, 'com'),
        ...foreignersAnswers
    };

    return new Promise((resolve, reject) => {
        axios.post(moduleUrl(`CategoriesWithItems/${source}`), request)
                .then(response => {
                    if (response.data) {
                        let data = response.data;

                        initShowTable(data.topCategories);

                        resolve({
                            companies: data.companies,
                            topCategories: data.topCategories
                        });
                    }
                }).catch(error => {
            console.error(error);
            reject(error);
        });
    });
}

export function loadFavorites(source, axios, itemIds) {
    return new Promise((resolve, reject) => {
        axios.post(moduleUrl(`Favorites/${source}`), itemIds)
            .then(response => {
                if (response.data) {
                    let data = response.data;

                    initShowTable(data.topCategories);

                    resolve({
                        companies: data.companies,
                        topCategories: data.topCategories
                    });
                }
            }).catch(error => {
            console.error(error);
            reject(error);
        });
    });
}

export async function loadCompanies(axios, url, types = ["Mortgage", "PersonalLoan", "Building"]) {
    let allCompanies = [];

    for (const type of types) {
        try {
            const response = await axios.get(`${url}/${type}`);
            if (response.data) {
                const fetched = response.data.map(item => {
                    if (item.name === "ČS") {
                        item.name = "CS";
                    }
                    return { ...item, type };
                });
                allCompanies.push(...fetched);
            }
        } catch (err) {
            console.error(`Chyba při načítání typu ${type}:`, err);
        }
    }
    return sortBy(allCompanies, "name");
}
export async function loadMenuItems(axios, moduleUrl, types = ["Mortgage", "PersonalLoan", "Building"]) {
    let allItems = [];

    for (const type of types) {
        try {
            const response = await axios.get(moduleUrl(`Menu/${type}`));
            if (response.data) {
                const items = response.data.map(item => ({
                    id: item.id,
                    name: item.name,
                    desc: item.description,
                    query: item.query,
                    type: type
                }));
                allItems.push(...items);
            }
        } catch (err) {
            console.error(`Chyba při načítání menu typu ${type}:`, err);
        }
    }
    return sortBy(allItems, "name");
}
